import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useCookieConsent } from "./cookieConsent";

export const CookieBanner = () => {
  const { consent, accept, decline } = useCookieConsent();
  const navigate = useNavigate();

  return (
    <AnimatePresence>
      {!consent && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 md:inset-x-auto md:left-8 md:max-w-md z-[70] bg-white rounded-3xl shadow-[0_24px_60px_rgba(79,80,72,0.2)] border border-kern-taupe/15 p-6"
        >
          <div className="flex items-start gap-3">
            <span className="w-10 h-10 rounded-full bg-kern-sage/25 flex items-center justify-center shrink-0">
              <Cookie size={18} className="text-kern-olive" strokeWidth={1.8} />
            </span>
            <div>
              <h3 className="font-serif text-lg text-kern-dark leading-none">Cookies</h3>
              <p className="mt-2 text-sm text-kern-taupe leading-relaxed">
                Ik gebruik cookies om deze website goed te laten werken en om, met jouw
                toestemming, de kaart met mijn locatie te tonen.{" "}
                <button
                  data-testid="cookie-more-info"
                  onClick={() => navigate("/cookiebeleid")}
                  className="text-kern-terracotta underline underline-offset-2 hover:text-[#b98771] transition-colors"
                >
                  Meer info
                </button>
                .
              </p>
            </div>
          </div>
          <div className="mt-5 flex gap-3">
            <button
              data-testid="cookie-accept"
              onClick={accept}
              className="flex-1 rounded-full bg-kern-terracotta text-kern-bg text-sm font-medium py-2.5 hover:bg-[#b98771] transition-colors duration-300"
            >
              Accepteren
            </button>
            <button
              data-testid="cookie-decline"
              onClick={decline}
              className="flex-1 rounded-full bg-kern-sage/20 text-kern-dark text-sm font-medium py-2.5 hover:bg-kern-sage/30 transition-colors duration-300"
            >
              Weigeren
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
